import React, { FC } from "react";

import { useLabels } from "../Hooks/useLabels";

import { WaitlistViewModel } from "../../../Blocks/Waitlist/WaitlistViewModel.csharp";
import { SummaryPart } from "./SummaryPart";

type WaitWhileSummaryProps = {
  waitlist: WaitlistViewModel;
  awaitTime?: string;
};

export const WaitWhileSummary: FC<WaitWhileSummaryProps> = ({
  waitlist,
  awaitTime,
}) => {
  const { bookingLabels } = useLabels();

  const title =
    bookingLabels?.stepsBookingLabels.secondStepLabels.summarySubHeading ??
    "Oppsummering dine valg";

  return (
    <div className="card-bg-only row">
      <div className="py-2">
        <h3 className="h5">{title}</h3>
        <dl className="mb-0">
          {awaitTime && (
            <SummaryPart label="Ventetid">
              <span dangerouslySetInnerHTML={{ __html: awaitTime ?? "" }} />
            </SummaryPart>
          )}
          <SummaryPart 
            label="Sted" 
            content={waitlist.centerName} />
          <SummaryPart
            label="Behandling"
            content={waitlist.specializationName}
          />
          <SummaryPart 
            label="Type" 
            content={waitlist.serviceName} />
          <p className="mt-0">
            Ved behov, kan du enkelt avregistrere selv senere
          </p>
        </dl>
      </div>
    </div>
  );
};
